import * as React from 'react';

import { OfferCardContainer } from '../../../common/containers/OfferCardContainer';
import { OfferProvider } from '../../../common/containers/OfferCardContainer/OfferCardContext';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { BANNER_POSITIONS } from '../../constants';
import { BannerContainer } from '../BannerContainer';
import { OffersSuggestionsContainer } from '../OffersSuggestionsContainer';

interface IListingContainerProps {
  offers: IDailyRentOfferForMobileSite[];
}

export const ListingContainer = ({ offers }: IListingContainerProps) => {
  return (
    <>
      {offers.map((offer, index, offers) => {
        const position = index + 1;

        const offerContainer = (
          <OfferProvider key={offer.id} offer={offer} offerPosition={position} offersLength={offers?.length}>
            <OfferCardContainer />
          </OfferProvider>
        );
        if (position === 1) {
          return [offerContainer, <OffersSuggestionsContainer key={`offers-suggestions-${offer.id}`} />];
        } else if (BANNER_POSITIONS.includes(position)) {
          return [offerContainer, <BannerContainer key={`mortgage-${offer.id}`} />];
        } else {
          return offerContainer;
        }
      })}
    </>
  );
};
